import React, { useEffect, useState } from 'react';

import { AssessmentContainer, StepContainer } from './components';
import AcumenHeader from './components/acumen-header';

const candidateResults = [];

// eslint-disable-next-line @typescript-eslint/no-empty-function
function AssessmentManager({ steps = [], submitAssessment = () => {}, completeAssessment = () => {} }) {
  const [currentStepNum, setCurrentStepNum] = useState(-1);

  useEffect(() => {
    if (steps.length > 0 && currentStepNum === -1) {
      candidateResults.length = 0;
      setCurrentStepNum(0);
    }
  }, [steps, currentStepNum]);

  const moveNext = () => {
    const nextStep = currentStepNum + 1;
    if (nextStep >= steps.length) {
      completeAssessment();
    } else {
      setCurrentStepNum(currentStepNum + 1);
    }
  };

  const captureHandler = (result) => {
    if (result) {
      if (result?.trial > 0) {
        candidateResults.push(result);
      }
      if (result.submitResults) {
        submitAssessment([...candidateResults]);
        candidateResults.length = 0;
      }
    }
    moveNext();
  };

  const moveNextHandler = () => {
    moveNext();
  };

  return (
    <div>
      <AcumenHeader />
      <AssessmentContainer>
        {currentStepNum >= 0 && (
          <StepContainer step={steps[currentStepNum]} capture={captureHandler} moveNext={moveNextHandler} />
        )}
      </AssessmentContainer>
    </div>
  );
}

export default AssessmentManager;
